import { render, staticRenderFns } from "./SocialAuthBtns.vue?vue&type=template&id=0f6b58b8&scoped=true&"
import script from "./SocialAuthBtns.vue?vue&type=script&lang=js&"
export * from "./SocialAuthBtns.vue?vue&type=script&lang=js&"
import style0 from "./SocialAuthBtns.vue?vue&type=style&index=0&id=0f6b58b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b58b8",
  null
  
)

export default component.exports